import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SpinnerModalComponent } from './spinner-modal.component';
import { SpinnerService } from './spinner-modal.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, MatDialogModule],
  declarations: [SpinnerModalComponent],
  exports: [SpinnerModalComponent],
  providers: [SpinnerService],
  entryComponents: [SpinnerModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SpinnerModalModule {}
